var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ham hamRotate ham7",class:_vm.classActive,attrs:{"viewBox":"0 0 100 100","width":"80"},on:{"click":_vm.menuBurgerClick}},[_c('path',{staticClass:"line top",attrs:{"d":"m 70,33 h -40 c 0,0 -6,1.368796 -6,8.5 0,7.131204 6,8.5013 6,8.5013 l 20,-0.0013"}}),_vm._v(" "),_c('path',{staticClass:"line middle",attrs:{"d":"m 70,50 h -40"}}),_vm._v(" "),_c('path',{staticClass:"line bottom",attrs:{"d":"m 69.575405,67.073826 h -40 c -5.592752,0 -6.873604,-9.348582 1.371031,-9.348582 8.244634,0 19.053564,21.797129 19.053564,12.274756 l 0,-40"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/global/MenuBurger.vue